import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatedBackground, Content, ContentContainer, Logo, Wrapper, } from "./styled";
const Interstitial = ({ children, contentTestAttribute }) => (_jsx(Wrapper, { children: _jsxs(ContentContainer, { "data-testid": contentTestAttribute, children: [_jsx(AnimatedBackground, { "data-background": "true" }), _jsxs(Content, { children: [_jsx(Logo, {}), children] })] }) }));
export default Interstitial;
